import { Route } from "react-router-dom";
import ResourceNotFound from "../ResourceNotFound";
import DashboardTemplate from "../../Template/DashboardTemplate";
import { ISilderName, ItemRoutesProps } from "./PageRoute";
import { findUserPremission } from "../../Pages/Users/Roles/UserSecurityFind";
import { SettingsSections } from "../../Services/SettingService";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";
import { IPermissionActionType } from "../../Pages/Users/Roles/UserPermissionCommonData";
import SalesInvoiceTemplate from "../../Template/SalesInvoiceTemplate";
import ExpensesIncomeNestedRoute from "../../Pages/Expenses&income/ExpensesIncomeNestedRoute";
import AddExpensesInvoice from "../../Pages/Expenses&income/AddExpensesIncome";
import GroupDetails from "../../Pages/Master/Group/AllDetailsGroupWise/GroupDetails";
import { SearchLedgerByGroupsTypes } from "../../Services/LedgerService";
import LedgerDetails from "../../Pages/Master/Ledger/LedgerDetails";

const ExpensesAndIncomeRoute = ({
  currentClient,
  clientSpecificRole,
}: ItemRoutesProps) => {
  return (
    <>
      {/* ----------- Expenses & Income Route ----------- */}
      <Route
        key="expenses and income"
        path={`/${currentClient?.id}/*`}
        element={
          findUserPremission(
            [
              "Voucher.Expenses.14.View",
              "Voucher.Income.15.View",

              "Master.Ledger.Expenses.View",
              "Master.Ledger.Income.View",

              "Master.Group.Expenses.View",
              "Master.Group.Income.View",
            ],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Invoice, SettingsSections.Expenses],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <SalesInvoiceTemplate
              silderName={ISilderName.Expenses}
              element={<ExpensesIncomeNestedRoute />}
              breadcrumprops={[
                {
                  item: null,
                  path: `/books/clients/${currentClient?.id}/expenses`,
                },
              ]}
              menuprops={[
                {
                  showData: "Expenses",
                },
                {
                  showData: "Expenses Ledger",
                },
                {
                  showData: "Expenses Group",
                },
                {
                  showData: "Income",
                },
                {
                  showData: "Income Ledger",
                },
                {
                  showData: "Income Group",
                },
                {
                  showData: "Cost Centres",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Expenses Route */}
      <Route
        path={`${currentClient?.id}/expenses/addExpenses`}
        element={
          findUserPremission(
            ["Voucher.Expenses.14.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Expenses],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddExpensesInvoice />}
              breadcrumprops={[
                {
                  item: "Expenses",
                  path: `/books/clients/${currentClient?.id}/expenses`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/expenses/editExpenses/:updateId`}
        element={
          findUserPremission(
            ["Voucher.Expenses.14.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Expenses],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddExpensesInvoice />}
              breadcrumprops={[
                {
                  item: "Expenses",
                  path: `/books/clients/${currentClient?.id}/expenses`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/expenses/editExpensesDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Expenses.14.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Expenses],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddExpensesInvoice />}
              breadcrumprops={[
                {
                  item: "Expenses",
                  path: `/books/clients/${currentClient?.id}/expenses`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/expenses/cloneExpenses/:cloneId`}
        element={
          findUserPremission(
            ["Voucher.Expenses.14.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Expenses],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddExpensesInvoice />}
              breadcrumprops={[
                {
                  item: "Expenses",
                  path: `/books/clients/${currentClient?.id}/expenses`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Income Route */}
      <Route
        path={`${currentClient?.id}/income/addIncome`}
        element={
          findUserPremission(
            ["Voucher.Income.15.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Income],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddExpensesInvoice />}
              breadcrumprops={[
                {
                  item: "Income",
                  path: `/books/clients/${currentClient?.id}/income`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/income/editIncome/:updateId`}
        element={
          findUserPremission(
            ["Voucher.Income.15.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Income],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddExpensesInvoice />}
              breadcrumprops={[
                {
                  item: "Income",
                  path: `/books/clients/${currentClient?.id}/income`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/income/editIncomeDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Income.15.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Income],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddExpensesInvoice />}
              breadcrumprops={[
                {
                  item: "Income",
                  path: `/books/clients/${currentClient?.id}/income`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/income/cloneIncome/:cloneId`}
        element={
          findUserPremission(
            ["Voucher.Income.15.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Income],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddExpensesInvoice />}
              breadcrumprops={[
                {
                  item: "Income",
                  path: `/books/clients/${currentClient?.id}/income`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* Expenses Inside Details Routes */}
      <Route
        path={`/${currentClient?.id}/expensesLedger/:ledgerId`}
        element={
          <DashboardTemplate
            element={
              <LedgerDetails
                searchLedgerByGroupsTypes={
                  SearchLedgerByGroupsTypes.AllExpenses
                }
                showName="Expense"
              />
            }
            breadcrumprops={[
              {
                item: "Expenses",
                path: `/books/clients/${currentClient?.id}/expensesLedger`,
              },
              {
                item: "ExpensesLedger",
              },
            ]}
          />
        }
      />
      <Route
        path={`/${currentClient?.id}/expensesGroup/:groupId`}
        element={
          <DashboardTemplate
            element={
              <GroupDetails
                searchLedgerByGroupsTypes={
                  SearchLedgerByGroupsTypes.AllExpenses
                }
                showName="Expense"
              />
            }
            breadcrumprops={[
              {
                item: "Expenses Group",
                path: `/books/clients/${currentClient?.id}/expensesGroup`,
              },
              {
                item: "Group Details",
              },
            ]}
          />
        }
      />
      {/* Income Inside Details Routes */}
      <Route
        path={`/${currentClient?.id}/incomeLedger/:ledgerId`}
        element={
          <DashboardTemplate
            element={
              <LedgerDetails
                searchLedgerByGroupsTypes={
                  SearchLedgerByGroupsTypes.IndirectIncomeOnly
                }
                showName="Income"
              />
            }
            breadcrumprops={[
              {
                item: "Income",
                path: `/books/clients/${currentClient?.id}/income`,
              },
              {
                item: "IncomeLedger",
              },
            ]}
          />
        }
      />
      <Route
        path={`/${currentClient?.id}/incomeGroup/:groupId`}
        element={
          <DashboardTemplate
            element={
              <GroupDetails
                searchLedgerByGroupsTypes={
                  SearchLedgerByGroupsTypes.IndirectIncomeOnly
                }
                showName="Income"
              />
            }
            breadcrumprops={[
              {
                item: "Income Group",
                path: `/books/clients/${currentClient?.id}/incomeGroup`,
              },
              {
                item: "Group Details",
              },
            ]}
          />
        }
      />
    </>
  );
};

export default ExpensesAndIncomeRoute;
